import { BaseEdge, getSmoothStepPath, type EdgeProps } from "@xyflow/react";

/** Route long dependencies above cards so skipped groups do not look linked. */
export function PipelineEdge(props: EdgeProps) {
  const lane = props.data?.bypassY;
  const path =
    props.data?.relation === "contains"
      ? `M ${props.sourceX},${props.sourceY} H ${Math.min(props.sourceX, props.targetX) - 20} V ${props.targetY} H ${props.targetX}`
      : typeof lane === "number"
        ? `M ${props.sourceX},${props.sourceY} L ${props.sourceX + 14},${props.sourceY} L ${props.sourceX + 14},${lane} L ${props.targetX - 14},${lane} L ${props.targetX - 14},${props.targetY} L ${props.targetX},${props.targetY}`
        : getSmoothStepPath(props)[0];
  return (
    <BaseEdge
      id={props.id}
      path={path}
      style={props.style}
      markerEnd={props.markerEnd}
    />
  );
}
